import React, { useEffect, Suspense, lazy } from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { connect } from 'react-redux'
import { getAll } from '../actions'
import Layout from '../layout'
import Login from '../pages/Login'
import Dashboard from '../pages/Dashboard'
import Documentation from '../pages/Documentation'
import Loading from '../components/Loading'
import Orders from '../pages/Orders'
import OrdersDetail from '../pages/Orders/Detail'
import Colors from '../pages/Colors'
import ColorsCreate from '../pages/Colors/Create'
import ColorsUpdate from '../pages/Colors/Update'
import Subscriptions from '../pages/Subscriptions'

const App = ({ loggedIn, getAll, user, screensUsers }) => {
  useEffect(() => {
    getAll(`users/screens/${user.role || 0}`, 'GET_SCREENS_USERS')
    // eslint-disable-next-line
  }, [])

  if (!screensUsers) {
    return <Loading />
  }

  if (loggedIn) {
    return (
      <BrowserRouter>
        <Layout>
          <Routes>
            {/* Base Dashboard */}
            <Route path="/" element={<Dashboard />} />
            <Route
              path="/documentation"
              element={<Documentation />}
            />
            <Route path="/orders" element={<Orders />} />
            <Route path="/orders/detail/:id" element={<OrdersDetail />} />
            <Route path="/products/colors" element={<Colors />} />
            <Route path="/products/colors/create" element={<ColorsCreate />} />
            <Route path="/products/colors/:id" element={<ColorsUpdate />} />
            <Route path="/subscriptions" element={<Subscriptions />} />

            <Route path="/login" element={<Login />} />
            {/* End Base Dashboard */}

            {screensUsers.map(screen => {
              const Element = lazy(() =>
                import(`../pages/${screen.element}`)
              )

              return (
                <Route
                  key={screen.id}
                  path={screen.url}
                  element={
                    <Suspense fallback={<Loading />}>
                      <Element />
                    </Suspense>
                  }
                />
              )
            })}
          </Routes>
        </Layout>
      </BrowserRouter>
    )
  } else {
    return (
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="*" element={<Login />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    )
  }
}

const mapStateToProps = state => {
  return {
    user: state.reducerApp.user,
    screensUsers: state.users.screensUsers,
  }
}

const mapDispatchToProps = {
  getAll,
}

export default connect(mapStateToProps, mapDispatchToProps)(App)
